<template>
  <main class="flex-item" v-if="contract.kei01p !== undefined && contract.hsm03p !== undefined && contract.kei02p !== undefined">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">description</span>契約照会</p>
      </header>

      <div class="card-content pb-0">
        <div class="columns">
          <div class="column">
            <div class="is-flex is-flex-wrap-wrap">
              <div class="ml-auto">
                <button v-if="enablePrintYakkan" class="button is-primary is-normal is-medium mr-4" @click="downloadTerms">
                  <span class="material-icons">print</span>契約のしおり・約款出力
                </button>
                <button v-if="enablePrintSyoken" @click.prevent="downloadInsurancePolicy" class="button is-primary is-normal is-medium">
                  <span class="material-icons">print</span>証券出力
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 目的の所在地 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">home</span>目的の所在地</div>
          </header>
          <div class="card-content">
            <div class="columns ml-5">
              <div class="column py-1 is-4">
                <p>住所</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_khhka1" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1 is-4" />
              <div class="column has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_khhka2" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1 is-4">
                <p>住所（フリガナ）</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_khhka3" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 申込人（契約者）情報 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">person</span>申込人（契約者）情報</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">氏名</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekykj" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">氏名（フリガナ）</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekykn" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">郵便番号</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekyyn" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">住所</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekya1" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4" />
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekya2" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">住所（フリガナ）</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekya3" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">携帯電話番号</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekyt2" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">その他電話番号</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekytl" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">メールアドレス</p>
              </div>
              <div class="column is-7">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kekyma" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 被保険者 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">groups</span>被保険者</div>
          </header>
          <div class="card-content">
            <!-- 目的の所有者の代表者(undefindになることはないが一応) -->
            <div class="card block" v-if="mainInsured !== undefined">
              <input
                type="checkbox"
                id="owner-same-contractor"
                class="check-type-2 is-cb-medium"
                :true-value="constants.HAIIIE.HAI"
                :false-value="constants.HAIIIE.IIE"
                v-model="mainInsured.tf_khkysm"
                disabled
              />
              <header class="card-header">
                <div class="is-size-4 card-header-title">
                  <span class="material-icons accent-color">account_circle</span>目的の所有者の代表者
                  <label for="owner-same-contractor" class="is-size-6 ml-6 has-text-weight-bold has-text-dark">申込人と同じ</label>
                </div>
              </header>
              <div class="card-content">
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">氏名</p>
                  </div>
                  <div class="column">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_khhksj" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">氏名（フリガナ）</p>
                  </div>
                  <div class="column">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_khhksk" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">生年月日</p>
                  </div>
                  <div class="column">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_khhkbt" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">性別</p>
                  </div>
                  <div class="column">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="getGenderText(mainInsured.tf_khhksx)" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">携帯電話番号</p>
                  </div>
                  <div class="column is-7">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_khhkt2" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">その他電話番号</p>
                  </div>
                  <div class="column is-7">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_khhktl" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">メールアドレス</p>
                  </div>
                  <div class="column is-7">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_khhkma" />
                  </div>
                </div>
              </div>
            </div>

            <template v-if="subInsureds !== undefined">
              <SubInsured
                v-for="(v, i) in subInsureds"
                :key="i"
                :tf_khhkno="v.tf_khhkno"
                :tf_khhksj="v.tf_khhksj"
                :tf_khhksk="v.tf_khhksk"
                :tf_khhkbt="v.tf_khhkbt"
                :tf_khhksx="v.tf_khhksx"
              />
            </template>
          </div>
        </div>
      </div>

      <!-- 申込内容 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">article</span>申込内容</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">申込日</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="contract.kei01p.tf_kemsdt" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">保険期間</p>
              </div>
              <div class="column">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="`${contract.kei01p.tf_keskdt} ~ ${contract.kei01p.tf_kemkdt}`" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">契約区分</p>
              </div>
              <div class="column">
                <p class="mb-0 has-text-weight-bold">{{ contract.kei01p.tf_keksct === "00" ? "新規" : "更新" }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">建物</p>
              </div>
              <div class="column">
                <p class="mb-0 has-text-weight-bold">{{ getKozoText(mainInsured?.tf_khkozo ?? "") }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">物件</p>
              </div>
              <div class="column">
                <p class="mb-0 has-text-weight-bold">{{ getSyoyuText(mainInsured?.tf_khsykb ?? "") }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">目的</p>
              </div>
              <div class="column">
                <p class="mb-0 has-text-weight-bold">{{ getYoutoText(mainInsured?.tf_khytkb ?? "") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 補償内容 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">savings</span>補償内容</div>
          </header>
          <div class="card-content">
            <div class="is-size-5 block has-text-weight-bold">合計保険料</div>
            <div class="columns ml-2">
              <div class="column py-1 is-4">
                <p>合計金額</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <p class="is-size-5">{{ commaSplit(contract.kei01p.tf_kegkhk) }}円</p>
              </div>
            </div>

            <div class="is-size-5 block has-text-weight-bold">家財保険</div>
            <div class="columns ml-2">
              <div class="column py-1 is-4">
                <p>保険金額</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <p>{{ commaSplit(contract.hsm03p.tf_hrhkkg) }}万円</p>
              </div>
            </div>
            <div class="columns ml-2">
              <div class="column py-1 is-4">
                <p>保険料</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <p>{{ commaSplit(contract.hsm03p.tf_hrhrhk) }}円</p>
              </div>
            </div>

            <div class="is-size-5 block has-text-weight-bold">賠償責任保険</div>
            <div class="columns ml-2">
              <div class="column py-1 is-4">
                <p>保険金額</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <p>{{ commaSplit(contract.hsm03p.tf_hrhtkg) }}万円</p>
              </div>
            </div>
            <div class="columns ml-2">
              <div class="column py-1 is-4">
                <p>保険料</p>
              </div>
              <div class="column has-text-weight-bold py-1">
                <p>{{ commaSplit(contract.hsm03p.tf_hrhthk) }}円</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 意向確認 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">announcement</span>意向確認</div>
          </header>
          <div class="card-content">
            <table class="table is-bordered">
              <tbody>
                <tr>
                  <td class="pl-5">1. 申込人の住所・氏名・電話番号は正しく記載されています。</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">2. 目的の住所地・建物名・号室は正しく記載されています。</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">3. 被保険者（入居者）全員の氏名、生年月日、年齢、性別は正しく記載されています。</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">4. 「家財の保険金額」をご家族の構成等を目安に正しく決めました。</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">5. 契約内容を建物所有者・管理会社等が必要とするときは代理店を通じて提供することを承知します。</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">6. この保険は「家財」と「賠償責任」を保険の対象としています。ご確認頂けましたか？</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">7. 地震保険が付帯されていないことをご確認いただきましたか？</td>
                  <td>はい</td>
                </tr>
                <tr>
                  <td class="pl-5">8. 「保険金をお支払いできない場合」や「ご契約後の通知義務」についてご確認いただけましたか？</td>
                  <td>はい</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="columns is-centered" v-if="g$.length > 0">
        <div class="column is-10">
          <article class="message is-danger">
            <div class="message-body">
              <p v-for="(v, i) in g$" :key="i">{{ v }}</p>
            </div>
          </article>
        </div>
      </div>
      <footer class="card-footer">
        <div class="card-footer-item">
          <span>
            <router-link :to="{ name: 'Top' }" class="card-footer-item button is-normal is-medium"><div class="mx-3">戻る</div></router-link>
          </span>
        </div>
      </footer>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, Ref, UnwrapRef } from "vue";
import { contractResponse, getContract, kei02p } from "@/api/contract";
import HyphenParagraph from "common/src/components/HyphenParagraph.vue";
import constants from "common/src/constants";
import { getGenderText, getHaraikomiText } from "common/src/utils/codes";
import SubInsured from "common/src/components/SubInsured.vue";
import { commaSplit } from "common/src/utils/number";
import { contractChangeRequest, postContractChange } from "@/api/contractChange";
import useVuelidate from "@vuelidate/core";
import { SCR120FormValidateRule } from "@/forms/scr120";
import { addressRequest, getAddress } from "common/src/api/address";
import router from "@/router";
import axios from "axios";
import { setErrorMessage } from "common/src/utils/validate";
import { ErrorResponse } from "common/src/utils/request";
import { scrollToError } from "common/src/utils/screen";
import { getTerms } from "@/api/terms";
import { getSyoyuText, getYoutoText, getKozoText } from "common/src/utils/codes";
import { getFileNameFromContentDisposition } from "common/src/utils/file";
import { getInsurancePolicy } from "@/api/insurancePolicy";

// 仕様変更によりもともとこの画面に実装していた契約内容変更機能がなくなったため、
// scriptの多くは現時点では利用されることが無い
export default defineComponent({
  components: {
    HyphenParagraph,
    SubInsured,
  },
  setup() {
    const contract: UnwrapRef<contractResponse> = reactive({
      kei01p: undefined,
      hsm03p: undefined,
      kei02p: undefined,
    });
    const mainInsured: Ref<kei02p | undefined> = ref(undefined);
    const subInsureds: Ref<kei02p[] | undefined> = ref(undefined);
    const enablePrintYakkan = ref(true);
    const enablePrintSyoken = ref(true);

    const form: UnwrapRef<contractChangeRequest> = reactive({
      kei01p: {
        tfKekyyn: "",
        tfKekya1: "",
        tfKekya2: "",
        tfKekya3: "",
        tfKekytl: "",
        tfKekyt2: "",
        tfKehkdt: 0,
      },
    });

    // 契約情報取得
    getContract()
      .then((res) => {
        contract.kei01p = res.data.kei01p;
        contract.hsm03p = res.data.hsm03p;
        contract.kei02p = res.data.kei02p;

        mainInsured.value = res.data.kei02p?.find((i) => i.tf_khhkno === constants.MAIN_INSURED_NUMBER);
        subInsureds.value = res.data.kei02p
          ?.filter((i) => i.tf_khhkno !== constants.MAIN_INSURED_NUMBER)
          .sort((a, b) => Number.parseInt(a.tf_khhkno) - Number.parseInt(b.tf_khhkno));

        form.kei01p.tfKekyyn = res.data.kei01p?.tf_kekyyn;
        form.kei01p.tfKekya1 = res.data.kei01p?.tf_kekya1;
        form.kei01p.tfKekya2 = res.data.kei01p?.tf_kekya2;
        form.kei01p.tfKekya3 = res.data.kei01p?.tf_kekya3;
        form.kei01p.tfKekytl = res.data.kei01p?.tf_kekytl;
        form.kei01p.tfKekyt2 = res.data.kei01p?.tf_kekyt2;
        form.kei01p.tfKehkdt = res.data.kei01p?.tf_kehkdt;

        enablePrintYakkan.value = res.data.hsm03p?.tf_hrsknf === constants.SYOUKEN_HAKKO.ENABLE;
        enablePrintSyoken.value =
          res.data.hsm03p?.tf_hrsknf === constants.SYOUKEN_HAKKO.ENABLE &&
          res.data.kei01p?.tf_kemskr === constants.MOUSHIKOMI_KEIRO.WEB &&
          res.data.kei01p?.tf_keybd1?.length > 0;
      })
      .catch((err) => {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          router.push({ name: "404" });
        }
      });

    // 全体エラーメッセージ
    const g$: string[] = reactive([]);
    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({
      kei01p: {},
    });
    // フィールドエラー設定初期化
    const f$ = useVuelidate(SCR120FormValidateRule, form, {
      $autoDirty: true,
      $externalResults,
    });

    // 電話番号入力時の検証処理
    const validTelNo = () => {
      $externalResults.value = {
        ...$externalResults.value,
        ...{ kei01p: { tfKekytl: [], tfKekyt2: [] } },
      };
      f$.value.kei01p.tfKekytl.$touch();
      f$.value.kei01p.tfKekyt2.$touch();
      if (!form.kei01p.tfKekytl && !form.kei01p.tfKekyt2) {
        $externalResults.value.kei01p = {
          ...$externalResults.value.kei01p,
          ...{ tfKekytl: ["いずれかの電話番号を入力してください"], tfKekyt2: ["いずれかの電話番号を入力してください"] },
        };
      }
    };

    // 郵便番号入力時の住所取得処理を実装
    const getContractorAddress = async () => {
      if (form.kei01p.tfKekyyn?.length === 7) {
        const req: addressRequest = { zipCode: form.kei01p.tfKekyyn };
        try {
          const res = await (await getAddress(req)).data;
          form.kei01p.tfKekya1 = res.tf_ybthkj + res.tf_ybsckj + res.tf_ybcikj;
          form.kei01p.tfKekya3 = res.tf_ybthkn + res.tf_ybsckn + res.tf_ybcikn;
        } catch (err) {
          return;
        }
      }
    };

    // web保険証券出力処理
    const downloadInsurancePolicy = async () => {
      try {
        const res = await getInsurancePolicy();
        const file = new Blob([res.data]);
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        const name = getFileNameFromContentDisposition(res.headers["content-disposition"], "insurancePolicy.pdf");
        link.setAttribute("download", name);
        document.body.append(link);
        link.click();
        link.remove();
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          router.push({ name: "404" });
        }
      }
    };

    // 約款出力処理
    const downloadTerms = async () => {
      try {
        const res = await getTerms();
        const file = new Blob([res.data]);
        const url = window.URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        const name = getFileNameFromContentDisposition(res.headers["content-disposition"], "terms.pdf");
        link.setAttribute("download", name);
        document.body.append(link);
        link.click();
        link.remove();
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          router.push({ name: "404" });
        }
      }
    };

    // 契約情報変更処理呼び出し
    const submit = async () => {
      g$.splice(0, g$.length);
      f$.value.$clearExternalResults();
      validTelNo();
      f$.value.$touch();
      if (f$.value.$invalid) {
        scrollToError();
        return;
      }

      try {
        await postContractChange(form);

        router.push({ name: "ContractChanged" });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 400) {
          const extError = ref({});
          setErrorMessage(g$, extError, err.response?.data as ErrorResponse);
          $externalResults.value = {
            ...$externalResults.value,
            ...extError.value,
          };
          scrollToError();
        }
        if (axios.isAxiosError(err) && err.response?.status === 409) {
          g$.push("すでにデータが変更されています。画面を更新後、再度実行してください");
        }
      }
    };

    return {
      form,
      contract,
      constants,
      mainInsured,
      subInsureds,
      enablePrintYakkan,
      enablePrintSyoken,
      getGenderText,
      getHaraikomiText,
      commaSplit,
      f$,
      g$,
      validTelNo,
      getContractorAddress,
      downloadTerms,
      submit,
      getSyoyuText,
      getYoutoText,
      getKozoText,
      downloadInsurancePolicy,
    };
  },
});
</script>
